import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { NewsUpdate } from "../../../Constant";
import { H5, Image, LI, P, UL } from "../../../AbstractElements";
import { NEWS_UPDATE_DATA } from "../../../Data/Dashboard";
import { dynamicImage } from "../../../Service/DynamicImage";

const NewsAndUpdate = () => {
  return (
    <Col xl="4" sm="12" md="6" className="box-col-5">
      <Card>
        <CommonCardHeader title={NewsUpdate} className="card-no-border" />
        <CardBody className="pt-0">
          <UL className="news-box simple-list">
            {NEWS_UPDATE_DATA.map((item, index) => (
              <LI key={index}>
                <div className="d-flex">
                  <div className="flex-shrink-0">
                    <Image src={dynamicImage(`dashboard/${item.image}`)} alt="" />
                  </div>
                  <div className="flex-grow-1">
                    <H5>{item.title}</H5>
                    <P>{item.text}</P>
                  </div>
                  <span>{item.time}</span>
                </div>
              </LI>
            ))}
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default NewsAndUpdate;
